<template>
  <div class="xero-connect">
    <div v-if="loading" class="loading">
      <span>Checking Xero connection...</span>
    </div>
    <div v-else>
      <div v-if="isConnected" class="connected">
        <h3>Connected to Xero</h3>
        <button @click="handleDisconnect" class="btn btn-primary bg-red-100 text-red-600 ring-red-600 inline-flex items-center rounded-md px-3 py-2 text-sm font-medium ring-1 ring-inset">
          Disconnect from Xero
        </button>
      </div>
      <div v-else class="not-connected">
        <h3>Not Connected to Xero</h3>
        <button @click="handleConnect" class="btn btn-primary bg-blue-100 text-blue-600 ring-blue-600 inline-flex items-center rounded-md px-3 py-2 text-sm font-medium ring-1 ring-inset">
          Connect to Xero
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import xeroService from '../services/xero';

export default {
  name: 'XeroConnect',
  
  data() {
    return {
      loading: true,
      isConnected: false,
      error: null,
      // Define scopes and redirect URI here or fetch from config if needed client-side
      // Note: Redirect URI primarily needs to match what's in Xero Dev Console and handled by api/auth.js
      xeroScopes: ['openid', 'profile', 'email', 'accounting.settings', 'accounting.transactions', 'accounting.contacts', 'accounting.attachments', 'offline_access'],
      // This redirectUri is mainly for constructing the auth URL. The actual handling happens at api/auth.js
      // Ensure this matches the one expected/configured server-side if validation happens there.
      // Using the production URL here as an example, adjust if needed or make dynamic.
      xeroRedirectUri: `${process.env.NODE_ENV === 'development' ? 'http://localhost:3000' : 'https://pvis.edu.vu'}/api/auth`
    };
  },

  async created() {
    await this.checkConnection();
  },

  methods: {
    async checkConnection() {
      try {
        this.loading = true;
        // This calls the /api/checkConnection endpoint
        const status = await xeroService.checkConnection(); 
        this.isConnected = status.isConnected;
      } catch (error) {
        console.error('Error checking Xero connection:', error);
        this.error = error.message;
      } finally {
        this.loading = false;
      }
    },

    handleConnect() { // No longer needs to be async just for this part
      try {
        // Construct the URL directly on the client-side
        const clientId = process.env.VUE_APP_XERO_CLIENT_ID;
        
        if (!clientId) {
            console.error('VUE_APP_XERO_CLIENT_ID is not defined in the environment.');
            this.error = 'Client configuration error.';
            return; // Stop if client ID is missing
        }

        const state = Math.random().toString(36).substring(7);
        const url = `https://login.xero.com/identity/connect/authorize?` +
          `response_type=code` +
          `&client_id=${clientId}` +
          `&redirect_uri=${encodeURIComponent(this.xeroRedirectUri)}` +
          `&scope=${encodeURIComponent(this.xeroScopes.join(' '))}` +
          `&state=${state}`;

        // Store state in localStorage for verification on callback (good practice)
        localStorage.setItem('xero_auth_state', state);
        
        // Redirect the user
        window.location.href = url;

      } catch (error) {
        console.error('Error preparing Xero connection redirect:', error);
        this.error = error.message;
      }
    },

    async handleDisconnect() {
      try {
        // This calls the /api/disconnectXero endpoint
        await xeroService.disconnect(); 
        this.isConnected = false;
      } catch (error) {
        console.error('Error disconnecting from Xero:', error);
        this.error = error.message;
      }
    }
  }
};
</script>

<style scoped>
.xero-connect {
}

.loading {
  text-align: center;
  padding: 20px;
}

.connected, .not-connected {
  text-align: center;
}

button:hover {
  opacity: 0.9;
}
</style> 